//Search URLs 302 rediection start
(function() {
var urlParams = new URLSearchParams(window.location.search);
var searchParam = urlParams.get('s');

// Check if WordPress search query 's' exists
if (searchParam && window.location.pathname === '/') {
    var newUrl = '/search?q=' + encodeURIComponent(searchParam);
    window.location.replace(newUrl);
}
})();
//Search URLs 302 rediection end